import type { BuyContractPriceOption } from '@erp/rpc';
import type { VendorPriceBreakTier } from '@erp/rpc';
import type { LegPriceBreak } from '@erp/shared-types';
import { shouldShowBuyCostPricingPopover } from './buyCostPricingPopoverVisibility';

export function hasUnitCostPricingDropdown({
  tiers,
  options,
  priceBreak,
  quantity,
}: {
  tiers: readonly VendorPriceBreakTier[];
  options: readonly BuyContractPriceOption[];
  priceBreak: LegPriceBreak | null | undefined;
  quantity: number | null | undefined;
}): boolean {
  if (tiers.length > 0) return true;
  return shouldShowBuyCostPricingPopover({ options, priceBreak, quantity });
}

export function showUnitCostContractMarker({
  options,
  priceBreak,
  quantity,
}: {
  options: readonly BuyContractPriceOption[];
  priceBreak: LegPriceBreak | null | undefined;
  quantity: number | null | undefined;
}): boolean {
  return shouldShowBuyCostPricingPopover({ options, priceBreak, quantity });
}
